import { useConfirm } from 'components/Alert/useConfirm';
import { useMutation } from 'query';
import { moreInfo } from 'scenes/FinancePage/SA/data/queryKeyFactory';
import { moreInfoSA } from 'scenes/FinancePage/SA/sources';

export const useMoreInfo = () => {
  const confirm = useConfirm();

  const approveMutation = useMutation(moreInfo(), moreInfoSA, {
    refresh: true,
    successMessage: () => `More info requested`,
  });

  const handleAction = ({ id }: any) => {
    //todo ask comment in confirm dialog
    confirm({
      title: `Request More Info about the Spend Adjustment?`,
      confirmActionLabel: 'Request More Info',
    }).then(() => approveMutation.mutateAsync({ id }));
  };

  return [handleAction, approveMutation];
};
